import { FunctionComponent } from 'react';

import { ClaimFlowType } from 'types';

import { Button } from 'chime-ui/components/Button';
import { SmallTitle, StandardText } from 'chime-ui/components/Typography';

import useTransactionType from 'hooks/useTransactionType';

import ErrorGeneric from './Generic';

type ErrorExpiredProps = {
  referralToken: string;
};

const ErrorExpired: FunctionComponent<ErrorExpiredProps> = ({
  referralToken,
}) => {
  const { claimType } = useTransactionType();
  const isReceiveClaimFlow = claimType === ClaimFlowType.receive;

  if (isReceiveClaimFlow) {
    return (
      <ErrorGeneric cta={null} showLogin={false}>
        <SmallTitle>Dang! Transaction expired.</SmallTitle>
        <StandardText>This transaction is no longer available.</StandardText>
      </ErrorGeneric>
    );
  }

  return (
    <ErrorGeneric
      cta={
        <Button
          as="a"
          href={`${process.env.MARKETING_HOST}/r/${referralToken}`}
        >
          Join Chime
        </Button>
      }
    >
      <SmallTitle>Dang! Payment expired.</SmallTitle>
      <StandardText>
        This payment is no longer available. Ask your friend to send money
        again.
      </StandardText>
      <br />
      <StandardText>
        You can still join Chime, and you&apos;ll get $100 when you set up a
        qualifying direct deposit of $200+ within 45 days of enrolling.
      </StandardText>
    </ErrorGeneric>
  );
};

export default ErrorExpired;
